import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "../../../Containers/ContainerCreate";
import { getChimneyProfileWebsites } from "../../../api/getChimneyProfile";
import Spinner from "react-bootstrap/Spinner";

class ChimneyProfileWebsitesContainer extends React.Component {
  componentDidMount() {
    const { chimDir } = this.props;
    this.props.request(chimDir);
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const websites = (data && data.data) || [];
    if (loading) {
      return <Spinner animation="border" variant="secondary" />;
    }
    if (!loading && websites.length === 0) {
      return null;
    }
    return render({ websites, loading, failure });
  };
}

ChimneyProfileWebsitesContainer.propTypes = {
  chimDir: PropTypes.string.isRequired
};

export default CreateContainer(getChimneyProfileWebsites, ChimneyProfileWebsitesContainer);
